<template>
  <v-app>
    <e-drawer />
    <e-toolbar />
    <v-main>
      <v-btn
        v-show="!online"
        block
        depressed
        :ripple="false"
        class="warning"
        small
        >Sin conexión a internet</v-btn
      >
      <v-container fluid class="pa-0">
        <v-row>
          <v-col
            cols="12"
            :sm="en_reportes ? 12 : 8"
            :offset-sm="en_reportes ? 0 : 2"
            :xl="en_reportes ? 12 : 6"
            :offset-xl="en_reportes ? 0 : 3"
          >
            <transition name="fade">
              <router-view></router-view>
            </transition>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <v-dialog :value="offline_modal" persistent max-width="400">
      <v-card class="warning">
        <v-card-title>Intente más tarde...</v-card-title>
        <v-card-text
          >La acción que está intentando ejecutar requiere de conexión a
          internet.</v-card-text
        >
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="$store.commit('ui/updateOfflineModal', false)"
            >Entiendo</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog :value="unauthorized_modal" persistent max-width="500">
      <v-card class="px-3" style="height: 900px">
        <!-- Sección de Iniciar sesión -->
        <div v-if="activeStep === 'login'" class="iniciar">
          <v-col cols="12" class="text-center">
            <h2>Ingresar en Compa360</h2>
            <div
              class="d-flex justify-center flex-wrap mt-2"
              style="gap: 10px; align-items: center"
            >
              <span style="font-size: 30px">🐄</span>
              <v-icon large color="#4A90E2">mdi-fish</v-icon>
              <v-icon large color="#FBE8A6">mdi-egg</v-icon>
              <v-icon large color="#FF9800">mdi-carrot</v-icon>
              <v-icon large color="#DAA520">mdi-factory</v-icon>
              <v-icon large color="#228B22">mdi-tree</v-icon>
              <v-icon large color="#3F51B5">mdi-camera</v-icon>
              <v-icon large color="amber">mdi-flask</v-icon>
            </div>
          </v-col>

          <v-row justify="center" class="d-flex" no-gutters>
            <v-col cols="9">
              <v-text-field
                dense
                v-model="email"
                :rules="mostrarErrorEmail ? [r.email] : []"
                type="email"
                outlined
                append-icon="mdi-account"
                label="Usuario ( Correo)"
                autofocus
                @keyup.enter="iniciarSesion"
                @blur="validarEmailBlur"
                @input="mostrarErrorEmail = false"
              ></v-text-field>
            </v-col>
            <!-- Campo trampa (honeypot) -->
            <div style="display: none">
              <input type="text" v-model="honeypot" />
            </div>
            <v-col cols="9">
              <v-text-field
                dense
                v-model="password"
                :rules="[r.max()]"
                :type="see_pass ? 'text' : 'password'"
                outlined
                :append-icon="see_pass ? 'mdi-eye-off' : 'mdi-eye'"
                label="Contraseña"
                @keyup.enter="iniciarSesion"
                @click:append="see_pass = !see_pass"
              ></v-text-field>
            </v-col>

            <v-col cols="9" class="text-center">
              <v-btn
                class="secondary--text"
                style="display: inline-block; width: 80%"
                @click="iniciarSesion"
                :disabled="!emailValido || !passwordValido"
              >
                Entrar
              </v-btn>
            </v-col>
            <v-col cols="9" class="text-center mt-2">
              <p
                class="regist"
                style="
                  margin: 2;
                  padding: 10px 0;
                  display: inline-block;
                  width: 80%;
                  text-align: center;
                  padding: 10px 0;
                  border: 1px solid #ccc;
                  border-radius: 4px;
                  color: #000;
                "
              >
                <a href="#" @click="showRegister">¿Primera Vez? Regístrate</a>
              </p>
            </v-col>
          </v-row>
          <v-col cols="12" class="sign text-center">
            <p>
              <a href="#" @click="showRecover">¿Olvidaste la contraseña?</a>
            </p>
          </v-col>
          <v-col cols="12" class="sign text-center">
            <p class="regist">¿Necesitas ayuda? Escríbenos al soportecompa360@cncpanama.org</p>
          </v-col>
          <!--  <v-btn class="text-left" text @click="cerrarModalAuth">
            <v-icon small left>mdi-arrow-left</v-icon>
          </v-btn> -->
        </div>

        <!-- Sección de Registrar -->
        <div v-else-if="activeStep === 'register'" class="registrar">
          <v-col cols="12" class="text-center">
            <h2>Bienvenido a Compa360</h2>
          </v-col>
          <div class="nom-ape">
            <v-col cols="12">
              <v-text-field
                ref="nombre"
                v-model="productor.primer_nombre"
                :rules="[(v) => !!v || 'Coloque algun nombre']"
                outlined
                label="Nombre*"
                append-icon="mdi-account"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                ref="apellido"
                v-model="productor.primer_apellido"
                :rules="[(v) => !!v || 'Coloque un apellido']"
                outlined
                label="Apellido*"
                append-icon="mdi-account"
              ></v-text-field>
            </v-col>
          </div>
          <!-- <v-col v-if="productor.tipo_id === 1" cols="12">
            <v-text-field
              v-model="productor.id"
              placeholder="#-###-###"
              :rules="[
                [1, 2].includes(productor.tipo_empresa) ? r.pa_id : true,
                r.required,
                r.max(23),
              ]"
              label="Identificación o Cedula*"
              append-icon="mdi-account"
              outlined
            />
          </v-col>
          <v-col v-else-if="productor.tipo_id === 2" cols="12">
            <v-text-field
              v-model="productor.id"
              :rules="[r.required, r.max(23)]"
              label="Pasaporte*"
              append-icon="mdi-account"
              outlined
            />
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="productor.fecha_nacimiento"
              label="Fecha de nacimiento*"
              range-type="birthdate"
              :rules="[r.required]"
              :date.sync="productor.fecha_nacimiento"
              placeholder="yyyy-mm-dd"
              outlined
              @change="validarFecha"
            />
            <p v-if="errorin" style="color: red">{{ errorin }}</p>
          </v-col> -->
          <v-col cols="12">
            <v-text-field
              ref="correo"
              v-model="resusers.email"
              :rules="[r.required]"
              :error-messages="erroresEmail"
              type="email*"
              outlined
              append-icon="mdi-at"
              label="Correo*"
              autofocus
              @keyup.enter="Registrar"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
              ref="password"
              v-model="resusers.password"
              :rules="passwordRules"
              :type="see_pass ? 'text' : 'password'"
              outlined
              :append-icon="see_pass ? 'mdi-eye-off' : 'mdi-eye'"
              label="Contraseña*"
              required
              @keyup.enter="Registrar"
              @blur="validarAlSalir"
              @click:append="see_pass = !see_pass"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
              ref="confirmPassword"
              v-model="confirmPassword"
              :rules="confirmPasswordRules()"
              :type="see_pass ? 'text' : 'password'"
              outlined
              :append-icon="see_pass ? 'mdi-eye-off' : 'mdi-eye'"
              label="Repite tu Contraseña*"
              required
              @keyup.enter="Registrar"
              @click:append="see_pass = !see_pass"
            ></v-text-field>
          </v-col>
          <!-- <v-col cols="12">
            <v-select
              v-model="productor.sexo"
              :items="sexo"
              item-text="descripcion"
              item-value="id"
              label="Sexo"
              outlined
            />
          </v-col> -->
          <!-- <div class="phone">
            <v-col cols="12">
              <v-text-field
                v-model.number="productor.telefono"
                :rules="[
                  r.min_num(1000000),
                  r.max_num(99999999),
                  (v) =>
                    !productor.tipo_telefono ||
                    !!productor.telefono ||
                    'Coloque el número de teléfono',
                ]"
                label="Número de Teléfono"
                outlined
              >
              </v-text-field>
            </v-col>
          </div> -->
          <v-col cols="12">
            <v-btn
              :loading="loading"
              block
              depressed
              class="primary"
              @keyup.enter="Registrar"
              @click="validarCorreo"
              >Siguiente
            </v-btn>
          </v-col>
          <v-col cols="12" class="sign">
            <p class="regist">
              <a href="#" @click="showLogin">Iniciar sesión</a>
            </p>
          </v-col>
        </div>

        <!-- Sección de Preguntas de Seguridad -->
        <div v-else-if="activeStep === 'questions'" class="preguntas">
          <v-col cols="12" class="text-center">
            <h2>Recuperación de contraseña</h2>
            <h4>Preguntas para recuperar contraseña</h4>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="resusers.q1"
              outlined
              required
              label="Nombre de tu primera mascota?*"
              autofocus
              @keyup.enter="Registrar"
            ></v-text-field>
          </v-col>
          <!-- <v-col cols="12">
            <v-text-field
              v-model="resusers.q2"
              outlined
              required
              label="Marca de tu primer auto?*"
              autofocus
              @keyup.enter="Registrar"
            ></v-text-field>
          </v-col> -->
          <v-col cols="12">
            <v-text-field
              v-model="resusers.q3"
              outlined
              required
              label="Nombre de tu mejor amigo/a de la infancia?*"
              autofocus
              @keyup.enter="Registrar"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="resusers.q4"
              outlined
              required
              label="Tu lugar favorito de vacaciones de niño/a?*"
              autofocus
              @keyup.enter="Registrar"
            ></v-text-field>
          </v-col>
          <!-- <v-col cols="12">
            <v-text-field
              v-model="resusers.q5"
              outlined
              required
              label="Nombre de tu mejor maestra/maestro?*"
              autofocus
              @keyup.enter="Registrar"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="resusers.q6"
              outlined
              required
              label="Cual fue tu primer trabajo?*"
              autofocus
              @keyup.enter="Registrar"
            ></v-text-field>
          </v-col> -->
          <v-col cols="12">
            <v-btn
              :loading="loading"
              block
              depressed
              class="primary"
              @keyup.enter="Registrar"
              @click="Registrar"
              >Registrar
            </v-btn>
          </v-col>
          <v-col cols="12" class="sign">
            <p class="regist">
              <a href="#" @click="showRegister">Volver</a>
            </p>
            <p>
              <a href="#" @click="showLogin">Iniciar sesión</a>
            </p>
          </v-col>
        </div>

        <!-- Sección de Recuperar Contraseña -->
        <div v-else-if="activeStep === 'recover'" class="recuperar">
          <v-col cols="12" class="text-center">
            <h2>Recuperar Contraseña</h2>
            <b> Introduzca su Correo </b>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="email"
              :rules="[r.email, r.required]"
              type="email*"
              outlined
              required
              append-icon="mdi-account"
              label="Correo*"
              autofocus
              @keyup.enter="verificarEmail"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-btn
              :loading="loading"
              block
              depressed
              class="primary"
              @keyup.enter="login"
              @click="verificarEmail"
              >Verificar
            </v-btn>
          </v-col>
          <v-col cols="12" class="sign">
            <p class="regist">
              <a href="#" @click="showLogin">Iniciar sesión</a>
            </p>
          </v-col>
        </div>
        <!-- Preguntas de recuperacion -->
        <div v-else-if="activeStep === 'rquestions'">
          <v-col cols="12" class="text-center">
            <h2>Preguntas de Seguridad</h2>
            <b> Responda las Preguntas </b>
          </v-col>
          <v-form>
            <v-col
              v-for="pregunta in preguntasSeleccionadas"
              :key="pregunta.id"
              cols="12"
            >
              <v-text-field
                v-model="answers[`q${pregunta.id}`]"
                :rules="[r.required]"
                :label="pregunta.texto"
                outlined
                clearable
                autofocus
                @keyup.enter="verifyAnswers"
              ></v-text-field>
            </v-col>
          </v-form>
          <v-col cols="12">
            <v-btn
              :loading="loading"
              block
              depressed
              class="primary"
              @keyup.enter="login"
              @click="verifyAnswers"
              >Recuperar
            </v-btn>
          </v-col>
          <v-col cols="12" class="sign">
            <p class="regist">
              <a href="#" @click="showLogin">Inicia Sesión</a>
            </p>
          </v-col>
        </div>
        <!-- New Password -->
        <div v-else-if="activeStep === 'newpass'">
          <v-col cols="12" class="text-center">
            <h2>Introduzca nueva contraseña</h2>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="nueva"
              :type="see_pass ? 'text' : 'password'"
              :append-icon="see_pass ? 'mdi-eye-off' : 'mdi-eye'"
              :rules="[r.password, r.max(16)]"
              label="Contraseña nueva*"
              outlined
              @click:append="see_pass = !see_pass"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="repetir_nueva"
              :type="see_pass ? 'text' : 'password'"
              :append-icon="see_pass ? 'mdi-eye-off' : 'mdi-eye'"
              persistent-hint
              :hint="no_igual ? 'Las contraseñas no coinciden' : ''"
              :error="no_igual"
              :rules="[r.password, r.max(16)]"
              label="Repetir contraseña nueva*"
              outlined
              @click:append="see_pass = !see_pass"
            ></v-text-field>
          </v-col>
          <v-btn @click="actualizarPassword">Guardar Contraseña</v-btn>
          <v-col cols="12" class="sign">
            <p class="regist">
              <a href="#" @click="showLogin">Iniciar sesión</a>
            </p>
          </v-col>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog :value="old_record_modal" persistent max-width="400">
      <v-card dark class="error">
        <v-card-title>Existen datos más recientes</v-card-title>
        <v-card-text>
          Existen datos más recientes para el registro o registros que se
          quieren sincronizar. Los registros que no se sincronizan se marcan con
          un signo de exclamación.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="$store.commit('ui/updatedOldRecordModal', false)"
            >Entendido</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog :value="existing_record_modal" persistent max-width="400">
      <v-card dark class="error">
        <v-card-title>Registro repetido</v-card-title>
        <v-card-text>
          Ya existe un registro con los datos que se quieren registrar. Por
          favor, busquelo para modificarlo. y elimine este registro, si no lo
          elimina se marcarán con color amarillo. Por favor eliminelo.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="$store.commit('ui/updatedExistingRecordModal', false)"
            >Entendido</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snack.show"
      bottom
      right
      :timeout="snack.timeout"
      :color="snack.color"
      >{{ snack.text }}
      <v-btn text @click="closeSnack">Cerrar</v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import EToolbar from './components/EToolbar'
import EDrawer from './components/EDrawer'
import * as rules from '@/utils/validations'
import { clona } from '@/utilidades'
import { formulario_de_productor } from '@/modelos'

export default {
  components: {
    EToolbar,
    EDrawer,
  },
  data: () => ({
    r: rules,
    listado_productores: '',
    loading: false,
    email: '',
    erroresEmail: [],
    errorin: '',
    honeypot: '', // Campo trampa que debería quedar vacío
    answers: { q1: '', q3: '', q4: '' },
    password: '',
    token: '',
    activeStep: 'login',
    preguntas: [],
    nueva: '',
    repetir_nueva: '',
    selectedQuestion: {},
    securityAnswer: null,
    preguntasSeguridad: [
      { id: 1, texto: 'Nombre de tu primera mascota?*' },
      // { id: 2, texto: 'Marca de tu primer auto?*' },
      { id: 3, texto: 'Nombre de tu mejor amigo/a de la infancia?*' },
      { id: 4, texto: 'Tu lugar favorito de vacaciones de niño/a?*' },
      { id: 5, texto: 'Nombre de tu primer maestra/maestro?*' },
      { id: 6, texto: 'Cual fue tu primer trabajo?*' },
    ],
    preguntasSeleccionadas: [], // Preguntas aleatorias que se mostrarán al usuario
    see_pass: false,
    registerActive: false,
    recoverActive: false,
    qsActive: false,
    mostrarErrorEmail: false,
    productor: {
      ...clona(formulario_de_productor),
      tipo_id: 1, // Establecer Cédula como predeterminada
      tipo_telefono: 1,
      estado: 3,
    },
    resusers: {
      id: '',
      role_id: 2,
      name: '',
      email: '',
      avatar: '{"locale":"es"}',
      email_verified_at: '',
      password: '',
      settings: 'users/default.png',
      id_institucion: 15,
      cnameagru: '',
      created_at: '',
      updated_at: '',
      id_agencia: '',
      idproy: '',
      estatus: 3,
      q1: '',
      q2: '',
      q3: '',
      q4: '',
      q5: '',
      q6: '',
      tipo_id: '',
      cedula: '',
      fecha_nacimiento: '',
    },
    newPassword: '',
    confirmPassword: '', // Campo para confirmar la contraseña
    passwordRules: [
      (v) => !!v || 'La contraseña es necesaria',
      (v) => v.length >= 8 || 'La contraseña debe tener al menos 8 caracteres',
      (v) =>
        /[A-Z]/.test(v) ||
        'La contraseña debe tener al menos una letra mayúscula',
      (v) =>
        /[a-z]/.test(v) ||
        'La contraseña debe tener al menos una letra minúscula',
      (v) => /[0-9]/.test(v) || 'La contraseña debe tener al menos un número',
    ],
  }),
  computed: {
    user() {
      return this.$store.getters['auth/user']
    },
    emailValido() {
      return rules.email(this.email) === true // Si la validación del correo es correcta
    },
    passwordValido() {
      return this.password.length > 0 // Verifica que haya algo escrito en la contraseña
    },
    no_igual() {
      return this.nueva !== this.repetir_nueva
    },
    en_reportes() {
      return this.$route.path.includes('/ru/reportes')
    },
    snack: {
      get() {
        return this.$store.state.ui.snack
      },
      set(value) {
        this.$store.commit('ui/setSnack', value)
      },
    },
    ...mapState('listados', ['sexo', 'tipo_telefono', 'tipo_identificacion']),
    ...mapState('ui', [
      'offline_modal',
      'unauthorized_modal',
      'old_record_modal',
      'existing_record_modal',
      'online',
    ]),
    ...mapGetters('auth', ['user']),
    ...mapGetters('registros', ['productor_actual']),
  },

  async mounted() {
    this.$store.dispatch('registros/ping')

    this.$store.dispatch('app/registrarPosicionActual')
    this.$store.commit('registros/definirTipoProductor')

    //NO QUITAR LA CARGA DE LISTADOS:
    await this.$store.dispatch('listados/sincronizar')

    // Selecciona una pregunta de seguridad aleatoria al cargar el componente
  },

  methods: {
    validarAlSalir() {
      // Solo valida si AMBOS campos tienen algo escrito
      if (this.resusers.password && this.confirmPassword) {
        this.$refs.confirmPassword.validate()
      }
    },
    // verifica que las credenciales ingresadas por el usuario sean correctas.
    // en caso de éxito redirige al listado de productores
    // Lógica para mostrar el formulario de registro
    limpiarFormulario() {
      this.email = ''
      this.errorin = ''
      this.honeypot = ''
      this.password = ''
      this.token = ''
      this.newPassword = ''
      this.confirmPassword = ''
      this.nueva = ''
      this.repetir_nueva = ''
      this.answers = { q1: '', q3: '', q4: '' }
      this.productor = {
        ...clona(formulario_de_productor),
        tipo_id: 1,
        tipo_telefono: 1,
        estado: 3,
      }
      this.resusers = {
        id: '',
        role_id: 2,
        name: '',
        email: '',
        avatar: '{"locale":"es"}',
        email_verified_at: '',
        password: '',
        settings: 'users/default.png',
        id_institucion: 15,
        cnameagru: '',
        created_at: '',
        updated_at: '',
        id_agencia: '',
        idproy: '',
        estatus: 3,
        q1: '',
        q2: '',
        q3: '',
        q4: '',
        q5: '',
        q6: '',
        tipo_id: '',
        cedula: '',
        fecha_nacimiento: '',
      }
    },
    showStep(step) {
      this.activeStep = step
    },
    // Actualizar los métodos showLogin, showRegister y showRecover
    showLogin() {
      this.limpiarFormulario()
      this.showStep('login')
    },
    showRegister() {
      this.limpiarFormulario()
      this.showStep('register')
    },
    showRecover() {
      this.showStep('recover')
    },
    showRecoverq() {
      this.showStep('rquestions')
    },
    showNewpass() {
      this.showStep('newpass')
    },
    showLaststep() {
      this.showStep('laststep')
    },

    confirmPasswordRules() {
      return [
        (v) => !!v || 'Por favor, confirma tu contraseña',
        // Solo comparar si los dos campos YA están llenos
        (v) => {
          if (!v || !this.resusers.password) return true // ✔️ Sin error todavía
          return v === this.resusers.password || 'Las contraseñas no coinciden'
        },
      ]
    },
    validarEmailBlur() {
      this.mostrarErrorEmail = true // Activa la validación cuando el usuario salga del campo
    },

    // Mostrar preguntas de seguridad
    showQS() {
      if (this.resusers.password !== this.confirmPassword) {
        this.$store.commit('ui/setSnack', {
          show: true,
          text: 'Las contraseñas no coinciden',
          color: 'error',
        })
        return
      }
      this.showStep('questions')
    },

    onCaptchaVerified() {
      this.captchaVerified = true
    },
    onCaptchaExpired() {
      this.captchaVerified = false
    },
    validarCorreo() {
      const campos = [
        this.$refs.nombre,
        this.$refs.apellido,
        this.$refs.correo,
        this.$refs.password,
        this.$refs.confirmPassword,
      ]

      let valid = true

      for (const campo of campos) {
        // Ejecuta validación del campo
        if (!campo.validate()) {
          valid = false
        }
      }

      if (!valid) {
        this.$store.commit('ui/setSnack', {
          color: 'error',
          text: 'Por favor completa todos los campos requeridos correctamente.',
        })
        return
      }

      const email = this.resusers.email
      if (!email) {
        this.$store.commit('ui/setSnack', {
          color: 'error',
          text: 'El Correo es necesario para su cuenta',
        })
        this.passwordRules()
      } else {
        this.error = false
        // Lógica para pasar a la siguiente pantalla
        this.showQS()
      }
    },

    validarFormulario() {
      // Acceder a los refs de los campos
      const nombreValido = this.$refs.nombre.validate()
      const apellidoValido = this.$refs.apellido.validate()
      const correoValido = this.$refs.correo.validate()
      const passwordValido = this.$refs.password.validate()
      const confirmPasswordValido = this.$refs.confirmPassword.validate()

      // Si alguno no es válido, detener el proceso
      if (
        !nombreValido ||
        !apellidoValido ||
        !correoValido ||
        !passwordValido ||
        !confirmPasswordValido
      ) {
        this.$store.commit('ui/setSnack', {
          color: 'error',
          text: 'Todos los campos son necesarios',
        })
        return
      }

      // Si todos los campos son válidos, proceder a la siguiente pantalla
      this.showQS()
    },

    validarFecha() {
      // Tu lógica de validación para la fecha de inicio
      let regexFecha = /^(\d{4})-(\d{2})-(\d{2})$/
      if (!regexFecha.test(this.productor.fecha_nacimiento)) {
        this.errorin =
          'Favor colocar año, mes y día separado con guiones así: yyyy-mm-dd'
      } else {
        let [, anio, mes, dia] =
          this.productor.fecha_nacimiento.match(regexFecha)
        if (parseInt(mes) < 1 || parseInt(mes) > 12) {
          this.errorin = 'El mes debe estar en el rango de 1 a 12.'
          return
        }
        let diasEnMes = new Date(anio, mes, 0).getDate()
        if (parseInt(dia) < 1 || parseInt(dia) > diasEnMes) {
          this.errorin = 'El día no es válido para el mes especificado.'
          return
        }
        this.errorin = ''
      }
    },

    async iniciarSesion() {
      try {
        console.log('G1')
        if (this.honeypot !== '') {
          console.log('G2')
          alert('Acceso denegado: se detectó actividad sospechosa.')
          return
        }

        //console.log('G3')
        this.loading = true

        //console.log('G4', this.email)
        //console.log('G5', this.password)
        const success = await this.$store.dispatch('auth/verifyCredentials', {
          email: this.email,
          password: this.password,
        })

        //console.log('G6', success)
        this.loading = false

        if (success) {
          //console.log('G7')
          this.cerrarModalAuth()

          if (navigator.onLine) {
            //console.log('G8')

           // console.log('G9', this.email)
            //console.log('G10', this.password)
            this.email = ''
            this.password = ''

            //console.log('G11', this.email)
            //console.log('G12', this.password)
            //aqui carga listado_productores si existe
            await this.buscarProductores()
            const elPrimero = this.listado_productores
            //console.log('G13')

            if (!elPrimero) {
              //console.log('G18')
              return this.$router.push('/ru/productor')
            } else {
              await this.cargarTodosLosProductores()
              //console.log('G14')
              //console.log('G15', this.listado_productores)
              //console.log('G16', elPrimero)
              this.$store.commit('ui/updateEDrawer', true)
              //console.log('G17')
              //console.log('G19')
              await this.traerRegistroYNavegar(elPrimero)
              //console.log('G20')
              return this.$router.push('/began')
            }
          } else if (this.listado_productores) {
            //console.log('G21')
            await this.cargarTodosLosProductores()
            const elPrimero = this.listado_productores
            await this.traerRegistroYNavegar(elPrimero)
            return this.$router.push('/began')
          } else {
            //this.$store.commit('ui/updateEDrawer', true)
            return this.$router.push('/ru/productor')
          }
        } else {
          this.$store.commit('ui/setSnack', {
            color: 'error',
            text: 'Correo o contraseña incorrecta',
          })
        }
      } catch (e) {
        this.loading = false
      }
    },
    
    async buscarProductores() {
      try {
        this.loading_search = true
        this.listado_productores = null
        //console.log("BP1") 
        //console.log("BP1", this.user)

        const res = await this.$store.dispatch('registros/listarCompas', {
          cnameagru: this.user.cnameagru,
          id: '',
        })
        //console.log("RES2")
        //console.log("RES2", res)
        const { status, data } = res

        if (status === 'ok') {
          this.listado_productores = data
        }
        
        //console.log("data3")
        //console.log("DATA3", data)
        this.loading_search = false
      } catch (e) {
        this.loading_search = false
      }
    },

    async cargarTodosLosProductores() {
      //console.log("F1")
      const fechaDesde = new Date()
      //console.log("F2",fechaDesde)

      fechaDesde.setMonth(fechaDesde.getMonth() - 36)
      //console.log("F3", fechaDesde)

      const fdesde = fechaDesde.toISOString().split('T')[0]
      //console.log("F4", fdesde)

      const fechaproddesde = fdesde
      //console.log("F5", fechaproddesde)

      const fhasta = new Date()
      //console.log("F6", fhasta)

      const fechaprodhasta = fhasta.toISOString().split('T')[0]
      //console.log("F7", fechaprodhasta)

      //console.log("F8", this.listado_productores)





      const primerProductor = this.listado_productores
      //console.log("F9", primerProductor)
      //console.log("F9.1", primerProductor.id)


      //console.log("F10")




      // ESTO ES NUEVO ANN ///////////////
      this.$store.commit('registros/productorActual', primerProductor.id)

      //console.log("F11")
      this.$store.commit('registros/definirTipoProductor')
      //console.log("F12")

      try {
      //console.log("F13")
        // Usamos Promise.all para esperar que todas las promesas se resuelvan
        // se carga el primero user.id de cnameagru
        
      //console.log("F14", primerProductor)
      //console.log("F15", fechaproddesde)
      //console.log("F16", fechaprodhasta)

        if (
          primerProductor != null &&
          primerProductor !== '' &&
          primerProductor !== 0 &&
          fechaproddesde != null &&
          fechaproddesde !== '' &&
          fechaproddesde !== 0 &&
          fechaprodhasta != null &&
          fechaprodhasta !== '' &&
          fechaprodhasta !== 0
        ) {
      //console.log("F17")

          await this.cargarProductore(
            primerProductor,
            fechaproddesde,
            fechaprodhasta
          )

        }
      } catch (e) {}
    },

    async cargarProductore(produ, fechapdesde, fechaphasta) {
      try {
        
      //console.log("H1")
        if (produ.id) {
          this.loading_add = true
          await this.$store.dispatch('registros/getExpediente', {
            id_productor: String(produ.id),
            fechaproddesde: fechapdesde,
            fechaprodhasta: fechaphasta,
          })
          this.$store.commit('ui/setSnack', {
            text: 'Datos agregados al dispositivo',
          })
        } else {
          alert('Por favor añada un Productor')
        }
      } catch (e) {
        console.error('Error al cargar productor:', e)
      } finally {
        this.loading_add = false
      }
    },

    async traerRegistroYNavegar(registro) {

      if (registro.sincronizado === true) {
        await this.$store.dispatch('registros/getProductor', {
          id: registro.id,
        })
      }
      //this.$store.commit('ui/updateEDrawer', true)
      if (this.$route.path !== `/ru/productor/${registro.id}`) {
        this.$router.push(`/ru/productor/${registro.id}`)
      }
    },

    seleccionarPreguntasAleatorias() {
      const preguntasMezcladas = [...this.preguntasSeguridad].sort(
        () => 0.5 - Math.random()
      )
      this.preguntasSeleccionadas = preguntasMezcladas.slice(0, 3)
    },
    async verificarEmail() {
      try {
        const response = await this.$store.dispatch('auth/forgotPassword', {
          email: this.email,
        })

        if (response) {
          // Si el correo existe, muestra la sección de preguntas de recuperación
          this.seleccionarPreguntasAleatorias()
          this.showRecoverq()
          this.errorMessage = ''
        } else {
          this.$store.commit('ui/setSnack', {
            color: 'error',
            text: 'Correo incorrecto o inexistente',
          })
        }
      } catch (error) {
        this.errorMessage =
          'Ocurrió un error al verificar el correo. Inténtalo de nuevo.'
        this.showRecoverq = false
      }
    },

    async verifyAnswers() {
      try {
        const response = await this.$store.dispatch('auth/verifyQuestions', {
          email: this.email,
          q1: this.answers.q1,
          // q2: this.answers.q2,
          q3: this.answers.q3,
          q4: this.answers.q4,
          // q5: this.answers.q5,
          // q6: this.answers.q6,
        })

        if (response?.success === true) {
          // Guardar el token recibido
          this.token = response.token

          // Pasar a la sección de nueva contraseña
          this.showNewpass()
        } else {
          this.$store.commit('ui/setSnack', {
            text: 'Una o varias respuestas son incorrectas. Inténtalo de nuevo.',
            color: 'error',
            timeout: 5000,
          })
        }
      } catch (error) {
        this.errorMessage =
          'Error al verificar las preguntas. Inténtalo de nuevo.'
      }
    },

    async actualizarPassword() {
      this.loading = true
      const response = await this.$store.dispatch('auth/resetPassword', {
        email: this.email,
        token: this.token,
        nueva: this.nueva,
        repetir_nueva: this.repetir_nueva,
      })
      if (response.success) {
        // Guardar el token recibido
        // this.token = response.data.token,
        this.$store.commit('ui/setSnack', {
          text: response.custom_message,
          color: 'success',
        })
        this.showLogin()
        this.nueva = ''
        this.repetir_nueva = ''
        this.$refs.form.reset()
      } else {
        this.$store.commit('ui/setSnack', {
          text: response.custom_message,
          color: 'error',
        })
      }
      this.loading = false
    },

    async Registrar() {
      try {
        // Verificar si todas las preguntas de seguridad están respondidas
        this.erroresEmail = []

        const preguntas = [
          this.resusers.q1,
          // this.resusers.q2,
          this.resusers.q3,
          this.resusers.q4,
          // this.resusers.q5,
          // this.resusers.q6,
        ]
        const preguntasIncompletas = preguntas.some((pregunta) => !pregunta)

        if (preguntasIncompletas) {
          this.$store.commit('ui/setSnack', {
            text: 'Favor conteste todas las preguntas y guarde en un lugar seguro su respuesta',
            color: 'error',
          })
          this.loading = false // Detener el loading
          return // Salir de la función si faltan respuestas
        }
        this.loading = true

        // Verificar si los campos necesarios están llenos
        if (!this.resusers.email || !this.resusers.password) {
          this.MensajesError = true // Mostrar mensaje de error
          return // Salir de la función si faltan campos necesarios
        }

        // Combinar 'primer_nombre' y 'primer_apellido' en 'resusers.name'
        this.resusers.name =
          `${this.productor.primer_nombre} ${this.productor.primer_apellido}`.trim()
        // Copiar datos de 'productor' a 'resusers'
        this.resusers.tipo_id = this.productor.tipo_id
        this.resusers.cedula = this.productor.id
        this.resusers.fecha_nacimiento = this.productor.fecha_nacimiento
        this.resusers.cnameagru = this.resusers.email

        // Obtener la fecha y hora actual en segundos desde la época UNIX
        const tiempoCreacion = Math.floor(new Date().getTime() / 1000)

        // Establecer la fecha y hora de creación si no existe
        if (!this.resusers.created_at) {
          this.resusers.created_at = tiempoCreacion
        }

        // Obtener la fecha y hora actual en el formato deseado y restar 5 horas
        const fechaHoraActual = new Date(new Date().getTime() - 5 * 3600 * 1000)
          .toISOString()
          .slice(0, 19)
          .replace('T', ' ')

        // Actualizar la fecha y hora de actualización
        this.resusers.updated_at = fechaHoraActual

        ////////////////////////////////////////////////////////////////
        // Guardar en la tabla users
        if (this.resusers.email && this.resusers.password) {
          const result = await this.$store.dispatch(
            'auth/guardarUsers',
            this.resusers
          )
          console.log("RESULT ES: ", result)
          // console.log("RESULT CON SUCCESS ES: ", result.success)
          //alert("result 1")

          if (!result.success) {
            //alert("result 2")
            this.erroresEmail = result.error?.email || []
            const msg =
              result.error?.email?.join(' ') ||
              'No se pudo registrar. Contacte a servicio tecnico de ayuda o verifique su correo y contraseñas.'
            this.$store.commit('ui/setSnack', { color: 'error', text: msg })
            return
          }

          if (result?.success) {
            console.log("HELLO")
            //alert("result 3")
            if (navigator.onLine) {
              //alert('ENTRE 1')
            }

            this.$store.commit('ui/setSnack', {
              text: 'Registro Exitoso',
              color: 'success',
              timeout: 5000,
            })
            this.showLogin()
            // Establecer un temporizador para ocultar el mensaje de confirmación después de 3 segundos
            setTimeout(() => {
              this.MostrarConfirmacion = false
            }, 3000)
          } else {
            // Si tu backend alguna vez devolviera success: false
            this.$store.commit('ui/setSnack', {
              text: 'No se pudo registrar.',
              color: 'error',
            })
          }
        }
      } catch (err) {
        // Error de red o 422, 429, etc.
        const status = err.response?.status
        const text =
          status === 422
            ? Object.values(err.response.data.errors).flat().join(' ')
            : 'No se pudo registrar. Contacte a servicio tecnico de ayuda o verifique su correo y contraseñas.'
        this.$store.commit('ui/setSnack', {
          text,
          color: 'error',
        })
      } finally {
        this.loading = false
      }
    },

    closeSnack() {
      this.$store.commit('ui/setSnack', { show: false })
    },

    cerrarModalAuth() {
      this.$store.commit('ui/updateUnauthorizedModal', false)
    },
  },
}
</script>
<style>
.campo-obligatorio {
  color: #1976d2 !important; /* Verde accesible */
  font-weight: 600;
}
.md2-border {
  border: 1px solid #d8d8d8 !important;
  border-radius: 7px !important;
}
.fade-enter-active {
  transition: opacity 0.5s;
}
.fade-enter /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.v-input {
  margin-bottom: -10px !important;
}
.opaque {
  opacity: 0.5;
}
</style>
